import { create } from 'jss'
import { jssPreset } from '@material-ui/core/styles'

const layerOffset = 1000000000
const materialUiJss = create(jssPreset())
const createStyleSheet = materialUiJss.createStyleSheet.bind(materialUiJss)

materialUiJss.createStyleSheet = (styles, options = {}) => {
	const { name } = options
	let { index } = options
	if (typeof name === 'string' && typeof index === 'number' && (name.startsWith('Mui') || name.startsWith('Private'))) {
		index -= name.endsWith('Base') ? layerOffset * 2 : layerOffset
	}
	return createStyleSheet(styles, { ...options, index })
}

export default materialUiJss